/* eslint-disable @typescript-eslint/explicit-member-accessibility */
export class ValidatorHolder<T> {
  private _current: T | null

  constructor() {
    this._current = null
  }

  get current(): T | null {
    return this._current
  }

  setCurrent(value: T | null): void {
    this._current = value
  }
}
